import { formatRelative } from "@amber/ui";

export function relativeLower(at: string): string {
  const text = formatRelative(at);
  if (text === "Now") return "just now";
  if (text === "Yesterday") return "yesterday";
  return text;
}
